import _template from 'lodash/template';

const template = (function(html, lodashMethods) {
  return {
    html,
    compile(templateData) {
      try {
        const initedTemplate = _template(html, { imports: lodashMethods });
        const compiledTemplate = initedTemplate(templateData);

        return compiledTemplate;
      } catch (templateError) {
        console.warn(new Error(templateError));
      }
    }
  };
});

export default template;
